import { useEffect, useRef, useState } from "react";

export const useMinimumLoading = (
  loading: boolean,
  minimumMs = 350,
): boolean => {
  const [visible, setVisible] = useState(loading);
  const startedAtRef = useRef<number | null>(loading ? Date.now() : null);
  const timeoutRef = useRef<number | null>(null);

  useEffect(() => {
    if (timeoutRef.current !== null) {
      window.clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }

    if (loading) {
      startedAtRef.current = Date.now();
      setVisible(true);
      return;
    }

    const startedAt = startedAtRef.current;
    if (startedAt === null) {
      setVisible(false);
      return;
    }

    const elapsed = Date.now() - startedAt;
    const remaining = Math.max(minimumMs - elapsed, 0);

    timeoutRef.current = window.setTimeout(() => {
      startedAtRef.current = null;
      timeoutRef.current = null;
      setVisible(false);
    }, remaining);

    return () => {
      if (timeoutRef.current !== null) {
        window.clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
    };
  }, [loading, minimumMs]);

  return visible;
};
